<template>
  <div style="background: white">
    <K2Row justify_content="center" class="position-relative p-4">
      <K2Row :style="{ background: uiVariable.color.button1 }" style="cursor: pointer" class="backButton pe-3 rounded po" align="center" @onclick="handleClick">
        <K2Icon color="white" name="chevron_left" font-size="29px" />
        <K2Text color="white">{{ lang('Back') }}</K2Text>
      </K2Row>
      <K2Heading type="h5" class-name="mb-0" color="black">{{ lang('Create New Post') }}</K2Heading>
    </K2Row>
    <div class="box base pt-3 p-md-3">
      <K2Row class="mobile-block">
        <!--left column-->
        <div class="col-12 col-md-9">
          <div class="box white p-3 mb-3">
            <K2Row space-between="true" align="center" class="border-bottom text-start mb-3 pb-3 activity__studentInfo">
              <K2Row style="flex-wrap: wrap" v-if="mselectedstudents.length && mselectedstudents[0]">
                <div class="newPostSetting__info" v-for="(item, i) in layoutConfig.studentInfo" :key="item.label">
                  <span class="k2Tag">{{ item.name }}</span> {{ item.value }}
                </div>
              </K2Row>
              <K2Row class="">
                <K2Button size="small" theme="2" class="me-2" @onclick="handleLoad('Template')">
                  {{ lang('Load From Template') }}
                </K2Button>
                <K2Button size="small" theme="2" @onclick="handleLoad('Draft')">
                  {{ lang('Load From Draft') }}
                </K2Button>
              </K2Row>
            </K2Row>

            <div class="box white mb-3">
              <K2Row align="center">
                <K2Text bold="true" class="text-left d-block me-3 mb-2">{{ lang('Select Post Type') }} </K2Text>
                <el-radio v-model="postType" label="Update" @change="onPostChange">
                  {{ lang('Feeds') }}
                </el-radio>
                <el-radio v-model="postType" label="Broadcast">
                  {{ lang('Broadcasts') }}
                </el-radio>
                <el-radio v-model="postType" label="Moment" @change="onPostChange">
                  {{ lang('Moments') }}
                </el-radio>
              </K2Row>
            </div>
            <K2Text bold="true" class-name="mb-2 text-left d-block" :style="{ fontSize: uiVariable.fontSize.lg }" required="true">{{ lang('Title') }} </K2Text>
            <div class="mb-3">
              <el-input v-model="state.title"></el-input>
            </div>
          </div>
          <activityStudents
            @tags="gTags($event)"
            @sAllLevels="pAllLevelsList($event)"
            @clearStudents="clearStudents"
            @handleResetGoals="handleResetGoals()"
            @isCheckAll="gAllLevels($event)"
            :postType="postType"
            @isAllClasses="gIsAllClasses($event)"
            @selectedclasses="gSelectedClasses($event)"
            @selectedLevels="gSelectedLevels($event)"
            @handleStudentPlannerOnSelect="handleStudentPlannerOnSelect"
            :passmselectedstudents="tselectedstudents"
            :passmseelctedclasses="tselectedclasses"
            :passSelectedLevel="tselectedLevels"
            :passisalllevel="misselectedalllevels"
          />
          <activityMedia @getselectedfiles="gSelectedUploadFiles($event)" :passselectedfile="tselectedfiles" :passPostType="postType" />
          <!--<div class="box white p-3 mb-3">-->
          <!--<K2Row space-between="true" class="border-bottom mb-4">-->
          <!--<K2Text align="left" bold="true" class-name="mb-3"-->
          <!--:style="{fontSize:uiVariable.fontSize.lg}">-->
          <!--{{layoutConfig.contentLabel||lang("Content")}}-->
          <!--</K2Text>-->
          <!--<div v-b-toggle="'activityContent'">-->
          <!--<K2Icon color="black" name="expand_less" class="when-open"/>-->
          <!--<K2Icon color="black" name="expand_more" class="when-closed"/>-->
          <!--</div>-->
          <!--</K2Row>-->
          <!--<b-collapse id="activityContent" visible>-->
          <!--<K2Editor v-model="content" @input="onEditorChange" :passContent="content"-->
          <!--:passIsMoment="postType === 'Moment'"/>-->
          <!--</b-collapse>-->
          <!--</div>-->
          <ActivityNewContent
            :title="postType === 'Broadcast' ? lang('Content') : layoutConfig.contentLabel"
            :id="layoutConfig.contentLabel"
            type="1"
            :postType="postType"
            :passContent1="state.content"
            @onChange="handleContentChange"
          />
          <div v-if="postType === 'Moment'">
            <ActivityNewContent
              :title="layoutConfig.content2Label"
              :id="layoutConfig.content2Label"
              type="2"
              :postType="postType"
              :passContent1="state.content2"
              @onChange="handleContentChange"
            />
          </div>
          <!--<div class="box white p-3 mb-3">-->
          <!--<K2Row space-between="true" class="border-bottom mb-4">-->
          <!--<K2Text align="left" bold="true" class-name="mb-3"-->
          <!--:style="{fontSize:uiVariable.fontSize.lg}">-->
          <!--{{lang("Observation")}}-->
          <!--</K2Text>-->
          <!--<div v-b-toggle="'activityContent'">-->
          <!--<K2Icon color="black" name="expand_less" class="when-open"/>-->
          <!--<K2Icon color="black" name="expand_more" class="when-closed"/>-->
          <!--</div>-->
          <!--</K2Row>-->
          <!--<b-collapse id="activityContent" visible>-->
          <!--<K2Editor v-model="observation" @input="onObservationChange" :passContent="observation"-->
          <!--:passIsMoment="postType === 'Moment'"/>-->
          <!--</b-collapse>-->
          <!--</div>-->
          <ActivityGoal
            v-if="postType !== 'Broadcast'"
            @developmentgoals="gDevelopmentGoals($event)"
            :mselectedstudents="mselectedstudents"
            :misselectedclasses="misselectedclasses"
            :goalsList="goalsList"
            :isMoment="postType === 'Moment'"
            :is3LevelGoals="is3LayerGoal"
            :tselectedGoals="tselectedGoals"
            @loadDomainList="loadDomainList"
            :porDevelopmentDomainList="porDevelopmentDomainList"
            :layoutConfig="layoutConfig"
          />
          <div v-if="postType === 'Update'" class="mt-3">
            <ActivityNewContent
              :title="layoutConfig.content2Label"
              :id="layoutConfig.content2Label"
              type="2"
              :passContent1="state.content2"
              :postType="postType"
              @onChange="handleContentChange"
            />
            <ActivityNewContent
              :title="layoutConfig.content3Label"
              :id="layoutConfig.content3Label"
              type="3"
              :passContent1="state.content3"
              :postType="postType"
              @onChange="handleContentChange"
            />
            <ActivityNewContent
              :title="layoutConfig.content4Label"
              :id="layoutConfig.content4Label"
              type="4"
              :passContent1="state.content4"
              :postType="postType"
              @onChange="handleContentChange"
            />
          </div>
        </div>
        <!--right column-->
        <div class="mt-3 mt-md-0 col-12 col-md-3">
          <ActivityPublish
            :passtaparent="content"
            :passObservation="observation"
            :posttitle="state.title"
            :passselectedfile="mselectedfiles"
            @handleLoad="handleLoad"
            :postType="postType"
            :isUpdate="isUpdate"
            :parentPost="updatePost"
            :userRole="userRole"
            :passmselectedstudents="mselectedstudents"
            :passkeytags="mselectedkeytags"
            :passSelectedLevel="mselectedlevels"
            :passmisselectedalllevels="misselectedalllevels"
            :passmisallclasses="misAllClasses"
            :passmseelctedclasses="misselectedclasses"
            :passmselectedlevels="misselectedLevels"
            :state="state"
            :layoutConfig="layoutConfig"
          />
          <ActivityTag @keytags="gKeytags($event)" :tpostkeytag="tpostkeytag" @handleRemoveGoals="handleRemoveGoals" />
        </div>
      </K2Row>
      <K2Modal
        :fullscreen="true"
        :dialog="modal === 'Template' || modal === 'Draft'"
        @handleClose="handleClose"
        @onConfirm="handleClose"
        :hideFooter="true"
        :hideHeader="true"
      >
        <K2Row justify_content="center" class="position-relative" align="center">
          <K2Icon color="black" name="chevron_left" @onclick="handleClose" link="true" class="backButton" style="top: 0" />
          <K2Heading type="h5" class-name="mb-0" color="black" v-if="isTemplate">{{ lang('Select Template') }} </K2Heading>
          <K2Heading type="h5" class-name="mb-0" color="black" v-else>{{ lang('Select Draft') }}</K2Heading>
        </K2Row>
        <ActivityTemplate @handleClose="handleClose" :modal="modal" @useTemplate="useTemplate" :templateList="templateList" @getTemplate="getTemplate" />
      </K2Modal>
    </div>
  </div>
</template>
<script>
import K2Heading from '../../uiComponents/k2Heading/k2Heading'
import K2Icon from '../../uiComponents/k2Icon/k2MAIcon'
import K2Row from '../../uiComponents/k2Row/k2Row'
import K2Text from '../../uiComponents/k2Text/k2Text'
import uiVariable from '../../config/uiVariable'
import K2Input from '../../uiComponents/k2Input/k2Input'
import K2Button from '../../uiComponents/k2Button/k2Button'
import './activity.scss'
import ActivityMedia from './component/newPostComponent/activityMedia'
import ActivityStudents from './component/newPostComponent/activityStudents'
import ActivityGoal from './component/newPostComponent/activityGoal'
import ActivityPublish from './component/newPostComponent/activityPublish'
import ActivityTag from './component/newPostComponent/activityTag'
import DataSource from '../../data/datasource'
import K2Modal from '../../uiComponents/k2Modal/k2Modal'
import ActivityTemplate from './component/newPostComponent/activityTemplate'
import Cookies from 'js-cookie'
import { lang } from '../../locale'
import K2Editor from '../../uiComponents/k2Editor/k2Editor'
import moment from 'moment'
import ActivityNewContent from './component/newPostComponent/activityNewContent'
import { getAge, getFormatDate } from '@/helper/utily'

export default {
  name: 'NewActivityPage',
  components: {
    ActivityNewContent,
    K2Editor,
    ActivityTemplate,
    K2Modal,
    ActivityTag,
    ActivityPublish,
    ActivityGoal,
    ActivityStudents,
    ActivityMedia,
    K2Button,
    K2Input,
    K2Text,
    K2Row,
    K2Icon,
    K2Heading,
  },
  props: ['handleBack', 'post'],
  data() {
    return (window.debug = {
      uiVariable: uiVariable,
      search: '',
      arrobj_Levels: [],
      studentList: null,
      title: '',
      content: '',
      observation: '',
      postType: null,
      mselectedfiles: [],
      mselectedstudents: [],
      mselectedlevels: [],
      tselectedLevels: [],
      mselectedkeytags: [],
      misselectedalllevels: '',
      misAllClasses: '',
      misselectedclasses: [],
      tselectedclasses: [],
      tselectedstudents: [],
      tselectedGoals: [],
      tpostkeytag: [],
      tselectedfiles: [],
      misselectedLevels: [],
      missingleselectclass: [],
      ddlLearningMomentsList: [],
      goalsList: [],
      porDevelopmentDomainList: [],
      porDevelopmentObject: [],
      modal: null,
      isTemplate: false,
      templateList: null,
      isUpdate: false,
      updatePost: null,
      ddlClassList: [],
      ddlLevelList: [],
      currentSchool: null,
      userRole: '',
      isSchool: false,
      useDraft: null,
      studentInfo: [],
      layoutConfig: '',
      state: { title: '' },
      is3LayerGoal: false,
      currentTerm: '',
      currentLevel: '',
    })
  },
  mounted() {
    this.init()
    this.currentSchool = Cookies.get('userSchoolNameSession')
    const self = this
    this.userRole = Cookies.get('userTypeSession')
  },
  methods: {
    lang,
    async init() {
      await this.sortByLevelClass()
      this.postType = 'Update'

      if (this.userRole === 'Principal') {
        // this.postType = "Update"; // since principal only has broadcast option, let's select by default.
        // this.misselectedalllevels = true;
        // this.misselectedLevels = this.ddlLevelList.map(x => ({ ...x, checked: true, isLevel: true }));
      }
      if (this.$route.params.post) {
        this.handleUpdate()
      }
      await this.handleSetting()
    },
    isNull(obj) {
      return obj === null || obj === undefined || obj === 'undefined' || obj.length === 0 || obj === ''
    },
    async onPostChange() {
      this.clearStudents()
      this.handleResetGoals()
      if (this.postType === 'Moment') {
        this.state.content3 = null
        this.state.content4 = null
      }
      this.handleSetting()
    },
    handleSetting(allClasses, gselectedstudents) {
      //layout setting for post type
      switch (this.postType) {
        case 'Update':
          this.layoutConfig = {
            contentLabel: lang('Intended Project Update'),
            content2Label: lang('Suggestions for Home-School Connection'),
            content3Label: lang('Language and Literacy Focus'),
            content4Label: lang('Numeracy Focus'),
            observation: false,
            studentInfo: allClasses && [
              { name: 'Class', value: allClasses?.join(', ') },
              { name: 'Term', value: this.currentTerm?.SEMD_DetailName },
              { name: 'Weeks', value: this.currentTerm?.noOfWeeks },
            ],
            goalMax: 5,
            goalMin: 3,
          }
          break
        case 'Moment':
          this.layoutConfig = {
            contentLabel: lang('Context'),
            content2Label: lang('Observation'),
            observation: true,
            studentInfo: gselectedstudents && [
              {
                name: 'Name',
                value: gselectedstudents[0]?.itemList?.First_Name || gselectedstudents[0]?.itemList[0]?.First_Name,
              },
              { name: 'Class', value: gselectedstudents[0]?.CLS_ClassName },
              { name: 'Age', value: gselectedstudents[0]?.itemList?.age || gselectedstudents[0]?.itemList[0]?.age },
            ],
            goalMax: 5,
            goalMin: 3,
          }
          // this.handleContentChange("", "content");
          // this.handleContentChange("", "content2");
          // this.handleContentChange("", "content3");
          // this.handleContentChange("", "content4");
          break
      }
    },
    onEditorChange(value) {
      this.content = value
    },
    onObservationChange(value) {
      this.observation = value
    },
    handleContentChange(value, name) {
      this.state = {
        ...this.state,
        [name]: value,
      }
    },
    handleUpdate() {
      let paramsPost = this.$route.params.post
      if (paramsPost) {
        this.isUpdate = true
        this.updatePost = paramsPost
        let {
          PostUpdDtlContent1,
          PostUpdDtlDescription,
          PostUpdDtlContent2,
          PostUpdDtlContent3,
          PostUpdDtlContent4,
          PostUpdDtlTitle,
          postFiles,
          PostType,
          PostKeyTags,
          PostLearningMoments,
          levelList,
          classList,
          studentList,
          school,
        } = paramsPost || {}
        this.state.content = (PostUpdDtlContent1 === 'null' ? '' : PostUpdDtlContent1) || PostUpdDtlDescription
        this.state.content2 = PostUpdDtlContent2 === 'null' ? '' : PostUpdDtlContent2
        this.state.content3 = PostUpdDtlContent3 === 'null' ? '' : PostUpdDtlContent3
        this.state.content4 = PostUpdDtlContent4 === 'null' ? '' : PostUpdDtlContent4
        this.state.title = PostUpdDtlTitle
        this.tselectedfiles = postFiles
        this.postType = PostType === 'Feed' ? 'Update' : PostType
        if (PostKeyTags) {
          PostKeyTags.forEach(d => {
            this.tpostkeytag.push(d.PostKeyTagValue)
          })
        }
        if (PostLearningMoments) {
          let tempGoalsList = []
          PostLearningMoments.forEach(d => {
            tempGoalsList.push({
              Domain: d.PostUpLMDomain,
              Goals: d.PostUpLMGoals,
              Indicator: d.PostUpLMIndicator,
              KeyId: d.PostUpLMPlnMasID,
              remarks: d.PostUpLMRemarks,
              termlyReport: d.PostUpLMTermReport,
            })
          })
          this.tselectedGoals = tempGoalsList
          this.state.PostLearningMoments = tempGoalsList
        }
        // if (paramsPost.school) {
        //   this.postType = "Broadcasts";
        // }
        if (levelList && levelList.length > 0) {
          this.tselectedLevels = levelList
        }
        if (classList && classList.length > 0) {
          this.tselectedclasses = classList
        }
        if (studentList && studentList.length > 0) {
          if (studentList) {
            this.tselectedstudents = studentList
          }
        }
        if (school) {
          this.misselectedalllevels = true
          this.tselectedLevels = this.ddlLevelList
        }
      }
    },
    gSelectedUploadFiles(gselectedfiles) {
      this.mselectedfiles = gselectedfiles
    },
    findSemesterReferenceRow(node) {
      if (!node) return null
      if (node.PK_Semester_ID) return node
      return this.findSemesterReferenceRow(node.ArrObj_Items?.[0])
    },
    async handleHeaderInfo() {
      try {
        let allClasses = []
        let selectedStudent = this.mselectedstudents?.[0]?.itemList?.[0]

        this.mselectedstudents?.forEach(d => {
          const exist = allClasses.find(x => x === d.CLS_ClassName)
          if (!exist) {
            allClasses.push(d.CLS_ClassName)
          }
        })

        // Students, classes, and levels can each be selected without the others (e.g. editing a post
        // that was tagged to a whole Class/Level), so fall back through them to resolve the term/semester.
        const semesterReference =
          selectedStudent || this.findSemesterReferenceRow(this.misselectedclasses?.[0]) || this.findSemesterReferenceRow(this.misselectedLevels?.[0])

        if (semesterReference) {
          const semesterDetail = await DataSource.shared.getSemesterTermDetailsBySemID(semesterReference?.PK_Semester_ID, '', 'Active')
          if (semesterDetail) {
            semesterDetail.Table.forEach((d, i) => {
              d.noOfWeeks = moment().diff(d.SEMD_FromDate, 'week')
              const currentDate = moment()
              d.momentEndDate = this.convertToMomentDate(d?.SEMD_ToDate_Convert)
              d.momentStartDate = this.convertToMomentDate(d?.SEMD_FromDate_Convert)
              d.finalEndDate = i === 3 ? d?.momentEndDate : this.convertToMomentDate(moment(d?.momentEndDate).subtract(1, 'days'))

              if (
                currentDate.isBetween(moment(d?.momentStartDate), moment(d?.finalEndDate)) ||
                [d?.momentStartDate, d?.finalEndDate]?.includes(this.convertToMomentDate(currentDate))
              ) {
                this.currentTerm = d
              }
            })
          }
        }

        if (selectedStudent) {
          const age = getAge(selectedStudent?.DOB)
          let years = age?.years
          let months = age?.months
          selectedStudent.age = `${years} year(s) ${months} month(s)`
        }
        this.handleSetting(allClasses, selectedStudent)
      } catch (e) {
        console.log('select student err', e)
      }
    },
    convertToMomentDate(date) {
      return getFormatDate(date, 'MM/DD/YYYY', 'DD/MM/YYYY')
    },
    checkIs3LayerGoal(list, isStudent) {
      // return list.find(d => d.CLS_ClassName.indexOf("PN") > -1 || d.CLS_ClassName.indexOf("N1") > -1 || d?.CLS_ClassName.indexOf("Pre-Nursery") > -1 || d?.CLS_ClassName.indexOf("Pre Nursery") > -1 || d?.CLS_ClassName.indexOf("Nursery 1") > -1);
      if (isStudent) {
        let student = list?.[0]?.itemList?.[0]
        this.currentLevel = student?.CRS_Course_Name
        return (
          student?.PK_Course_ID === 'CRS201400125' ||
          student?.PK_Course_ID === 'CRS201400111' ||
          student?.CRS_Course_Name?.includes('Nursery 1') ||
          student?.CRS_Course_Name?.includes('Pre-Nursery')
        )
      }
      this.currentLevel = list?.[0]?.ArrObj_Items?.[0]?.CRS_Course_Name || list?.[0]?.Str_Display
      return list.find(
        d =>
          d.levelID === 'CRS201400125' ||
          d.levelID === 'CRS201400111' ||
          d?.ArrObj_Items?.[0]?.CRS_Course_Name?.includes('Pre-Nursery') ||
          d?.ArrObj_Items?.[0]?.CRS_Course_Name?.includes('Nursery 1')
      )
    },
    async gTags(gselectedstudents) {
      let found = this.checkIs3LayerGoal(gselectedstudents, true)
      this.is3LayerGoal = !!found
      this.mselectedstudents = gselectedstudents
      // this.handleHeaderInfo(gselectedstudents);
    },
    pAllLevelsList(gselectedlevels) {
      this.mselectedlevels = gselectedlevels
    },
    gAllLevels(sisAlllevels) {
      this.misselectedalllevels = sisAlllevels
    },
    gIsAllClasses(sisAllClasses) {
      this.misAllClasses = sisAllClasses
    },
    gSelectedClasses(sSelectedClasses) {
      let found = this.checkIs3LayerGoal(sSelectedClasses)
      this.is3LayerGoal = !!found
      this.misselectedclasses = []
      this.misselectedclasses.push(...sSelectedClasses)
    },
    gSelectedLevels(sSelectedLevels) {
      let found = this.checkIs3LayerGoal(sSelectedLevels)
      this.is3LayerGoal = !!found
      this.misselectedLevels = sSelectedLevels
    },
    gSelectSingleClass(ssingleselectclass) {
      this.missingleselectclass = ssingleselectclass
    },
    gKeytags(gkeytags) {
      this.mselectedkeytags = gkeytags
      // alert(this.mselectedkeytags);
    },
    handleRemoveGoals(goalList) {
      this.goalsList = goalList
    },
    handleResetGoals() {
      this.tselectedGoals = []
      this.state.PostLearningMoments = []
      this.goalsList = []
      this.porDevelopmentDomainList = []
    },
    gDevelopmentGoals(gactivitygoals) {
      this.mselecteddevelopmentgoals = gactivitygoals
      //  alert(this.mselecteddevelopmentgoals);
    },
    showLoading() {
      this.$vs.loading()
    },
    hideLoading() {
      this.$vs.loading.close()
    },
    handleClick() {
      this.$router.push('/Activity')
    },
    handleInputChange(value, name) {
      this[name] = value
    },
    async handleStudentPlannerOnSelect() {
      this.$vs.loading()
      await this.handleHeaderInfo()
      await this.GetNewStudentPlanner()
      // if (this.is3LayerGoal) {
      //   await this.GetNewStudentPlanner();
      // } else {
      //   if (this.mselectedstudents) {
      //     await this.GetStudentPlanner();
      //   } else if (this.misselectedclasses) {
      //     await this.GetStudentPlannerByClass(this.misselectedclasses);
      //   }
      // }
      this.$vs.loading.close()
    },
    async GetNewStudentPlanner() {
      let studentList = [],
        classList = [],
        levelList = []
      if (this.misselectedLevels.length > 0) {
        this.misselectedLevels.forEach(d => {
          levelList.push(d.Str_ID)
        })
      } else if (this.misselectedclasses.length > 0) {
        this.misselectedclasses.forEach(d => {
          classList.push(d?.Str_ID)
          levelList.push(d?.levelID)
        })
      } else {
        this.mselectedstudents.forEach(item => {
          if (item?.itemList?.length) {
            item.itemList.forEach(d => {
              // let tempStudentIDList = {
              //   StudentID: d.Student_ID || d.PostTagUserID
              // };
              studentList.push(d?.Student_ID || d?.PostTagUserID)
              classList.push(d?.PK_Class_ID)
              levelList.push(d?.PK_Course_ID)
            })
          } else if (item?.itemList.length > 0) {
            // let tempStudentIDList = {
            //   StudentID: item.itemList.Student_ID || item.itemList.PostTagUserID
            // };
            studentList.push(item?.itemList?.Student_ID || item?.itemList?.PostTagUserID)
            classList.push(item?.itemList?.PK_Class_ID)
            levelList.push(item?.itemList?.PK_Course_ID)
          }
        })
      }
      const response = await DataSource.shared.getNewPlannerAssigned(classList, studentList, levelList)

      if (response) {
        if (response.code === '88') {
          window.location.replace('/')
        } else if (response.code === '99') {
          console.log('getPlannerAssignedStudentsGroupByClassID Error')
        } else if (response.code === '2') {
          console.log('getNewPlannerAssigned No Record')
        } else {
          let currentTermID = this.currentTerm?.SEMD_DetailName?.replace('Term ', '')
          let preschoolLevel = this.currentLevel?.includes('Pre-Nursery') ? 'PN' : 'N1'
          let goalFilter = this.is3LayerGoal ? preschoolLevel : 'T' + currentTermID
          this.goalsList = response?.Table?.filter(d => d.PlnMasLevels?.includes(goalFilter))
          this.goalsList.forEach((goal, gIndex) => {
            goal.KeyId = gIndex + 1
          })
          this.loadDomainList()
        }
      }
    },
    async GetStudentPlanner() {
      try {
        let StudentIDList = []
        let classID = []
        if (this.mselectedstudents[0] && this.mselectedstudents[0].classID) {
          let tempClassList = {
            classID: this.mselectedstudents[0].classID,
          }
          classID.push(tempClassList)
        } else if (this.mselectedstudents?.[0]?.itemList?.[0]) {
          let tempClassList = {
            classID: this.mselectedstudents?.[0]?.itemList?.[0]?.PK_Class_ID,
          }
          classID.push(tempClassList)
        } else if (this.mselectedstudents[0]) {
          this.ddlClassList.forEach(d => {
            if (this.mselectedstudents[0].CLS_ClassName) {
              if (d.Str_SortBy.trim() === this.mselectedstudents[0].CLS_ClassName.trim()) {
                let tempClassList = {
                  classID: d.Str_ID,
                }
                classID.push(tempClassList)
              }
            }
          })
        }
        this.mselectedstudents.forEach(item => {
          if (item?.itemList?.length) {
            item.itemList.forEach(d => {
              let tempStudentIDList = {
                StudentID: d.Student_ID || d.PostTagUserID,
              }

              StudentIDList.push(tempStudentIDList)
            })
          } else if (item?.itemList.length > 0) {
            let tempStudentIDList = {
              StudentID: item.itemList.Student_ID || item.itemList.PostTagUserID,
            }
            StudentIDList.push(tempStudentIDList)
          }
        })

        if (StudentIDList.length > 0) {
          const response = await DataSource.shared.getPlannerAssignedStudentsGroupByClassIDK2(classID, StudentIDList)

          if (response) {
            if (response.code === '88') {
              window.location.replace('/')
            } else if (response.code === '99') {
              console.log('getPlannerAssignedStudentsGroupByClassID Error')
            } else if (response.code === '2') {
              //comment due to effect loading speed
              // console.log('getPlannerAssignedStudentsGroupByClassID no record');
            } else {
              // const newArray = []
              // response.Table.forEach(d => {
              //   const exist = newArray.find(v => v.PlnStaDomain === d.PlnStaDomain)
              //   if (exist) {
              //     exist.PlnStaIndicator.push(d.PlnStaIndicator)
              //   } else {
              //     const newObj = {
              //       PlnStaDomain: d.PlnStaDomain,
              //       PlnStaIndicator: []
              //     }
              //     newArray.push(newObj)
              //   }
              // })
              this.goalsList = response.Table

              this.goalsList.forEach((goal, gIndex) => {
                goal.KeyId = gIndex + 1
              })
              this.loadDomainList()
            }
          }
        }
      } catch (e) {
        console.log('getPlannerAssignedStudentsGroupByClassID error', e)
      }
    },
    async GetStudentPlannerByClass(Classes) {
      try {
        let ClassIDList = []

        Classes.forEach(item => {
          let tempClassList = {
            classID: item.Str_ID,
          }
          ClassIDList.push(tempClassList)
        })

        let StudentIDList = []
        this.mselectedstudents.forEach(item => {
          item.itemList.forEach(d => {
            let tempStudentIDList = {
              StudentID: d.Student_ID,
            }
            StudentIDList.push(tempStudentIDList)
          })
        })

        // if (Classes.length > 0) {
        //     for (let item of Classes) {
        //         const response = await DataSource.shared.getPlannerAssignedStudentsGroupByClassIDK2(item.Str_ID);
        const response = await DataSource.shared.getPlannerAssignedStudentsGroupByClassIDK2(ClassIDList, StudentIDList)

        if (response) {
          if (response.code === '88') {
            window.location.replace('/')
          } else if (response.code === '99') {
            console.log('getPlannerAssignedStudentsGroupByClassID Error')
          } else if (response.code === '2') {
            console.log('getPlannerAssignedStudentsGroupByClassID no record')
          } else {
            this.goalsList = response.Table
            this.goalsList.forEach((goal, gIndex) => {
              goal.KeyId = gIndex + 1
            })
            this.loadDomainList()
          }
        }
        //     }
        // }
      } catch (e) {
        console.log('getPlannerAssignedStudentsGroupByClassID error', e)
      }
    },
    loadDomainList(porDevelopmentObject) {
      if (porDevelopmentObject) {
        this.state.PostLearningMoments = porDevelopmentObject
      }

      let sortedList = this.groupBy(this.goalsList, 'PlnMasDomain')
      for (let i = 0; i < sortedList.length; i++) {
        sortedList[i].ArrObj_Items = this.groupBy(sortedList[i].ArrObj_Items, 'PlnMasGoals')
      }
      this.porDevelopmentDomainList = []

      sortedList.forEach(item => {
        this.porDevelopmentDomainList.push(item)
      })
    },
    async sortByLevelClass() {
      try {
        const result = await DataSource.shared.getAllActiveStudentsBySchoolWithMode('ProfileImagePhysicalPath')
        if (result) {
          if (result.code === '88') {
            window.location.replace('/')
            return
          }
          if (this.isNull(result.Table)) {
            return
          }
          this.groupStudentList(result.Table)
        }
      } catch (e) {
        console.log('sortByLevelClass err', e)
      }
    },
    groupStudentList(result) {
      let classList = []
      let levelList = []
      let sortedList = this.groupBy(result, 'SMT_Code', 'SMT_Code')
      for (let i = 0; i < sortedList.length; i++) {
        let tempLevel = this.groupBy(sortedList[i].ArrObj_Items, 'CRS_Course_Name', 'CRS_Course_Name', 'PK_Course_ID')
        for (let j = 0; j < tempLevel.length; j++) {
          let tempClass = this.groupBy(tempLevel[j].ArrObj_Items, 'CLS_ClassName', 'CLS_ClassName', 'PK_Class_ID')
          tempLevel[j].ArrObj_Items = tempClass
        }
        sortedList[i].ArrObj_Items = tempLevel
      }
      sortedList.forEach(d => {
        d.ArrObj_Items.forEach(m => {
          levelList.push(m)
          m.ArrObj_Items.forEach(e => {
            classList.push(e)
          })
        })
      })
      this.ddlClassList = classList
      this.ddlLevelList = levelList
    },
    groupBy(data, key, display, id) {
      let ArrObj_Sorted = []
      let arrstr_display = !this.isNull(display) ? display.split(',') : [key]
      for (let item of data) {
        let index = ArrObj_Sorted.findIndex(x => x.Str_SortBy === item[key])
        if (index === -1) {
          let str_Display = ''
          for (let tempdisp of arrstr_display) str_Display += item[tempdisp] + ' '
          ArrObj_Sorted.push({
            Str_SortBy: item[key],
            Str_Display: str_Display,
            Str_ID: item[id],
            ArrObj_Items: [item],
          })
        } else ArrObj_Sorted[index].ArrObj_Items.push(item)
      }
      return ArrObj_Sorted
    },
    handleClose() {
      this.modal = null
    },
    handleLoad(type) {
      this.getTemplate(type)
      this.isTemplate = type === 'Template'
      this.modal = type
    },
    async useTemplate(feed) {
      this.isUpdate = false
      // if (this.modal === "Draft") {
      this.updatePost = feed
      // }
      this.modal = null
      this.misselectedclasses = []
      this.getTemplateFile(feed.POSTID)
      this.getTemplateKeyTag(feed.POSTID)
      this.getDevelopmentGoals(feed.POSTID)
      this.fetchPostSelectedTag(feed)
      if (feed) {
        // if(this.modal === "Draft" && feed.POSTID){
        //   this.useDraft = feed.POSTID
        // }

        this.postType = feed.PostType === 'Update' ? feed.PostType : feed.POSTTYPE
        // this.postType = feed.POSTSTATUS;
        await this.onPostChange()
        let content = feed.PostUpdDtlContent1 === 'null' ? '' : feed.PostUpdDtlContent1
        let content2 = feed.PostUpdDtlContent2 === 'null' ? '' : feed.PostUpdDtlContent2
        let content3 = feed.PostUpdDtlContent3 === 'null' ? '' : feed.PostUpdDtlContent3
        let content4 = feed.PostUpdDtlContent4 === 'null' ? '' : feed.PostUpdDtlContent4
        this.state.content = content || feed.PostUpdDtlDescription
        this.state.content2 = content2
        this.state.content3 = content3
        this.state.content4 = content4
        this.state.title = feed.PostUpdDtlTitle
        if (feed.PostUpLMDomain) {
          let tempGoals = {
            Domain: feed.PostUpLMDomain,
            Indicator: feed.PostUpLMGoals,
          }
          this.tselectedGoals.push(tempGoals)
        }
      }
    },
    async fetchPostSelectedTag(feed) {
      this.tselectedLevels = []
      this.tselectedclasses = []
      this.tselectedstudents = []
      const response = await DataSource.shared.getPostTagListByPostID(feed.POSTID)
      if (response.Table) {
        response.Table.forEach(d => {
          if (d.IsAllLevel) {
            this.isSchool = true
            this.misselectedalllevels = true
          } else {
            this.isSchool = false
            if (d.PostTagClassID) {
              // this.handleClassList(response.Table);
              this.tselectedclasses = response.Table
            } else if (d.PostTagLevelID) {
              this.tselectedLevels = response?.Table
              // this.handleLevelList(response.Table);
            } else {
              // this.handleStudent(response.Table);
              this.tselectedstudents = response.Table
            }
          }
        })
      }
    },
    //comment as unnecessary
    //
    // async handleStudent(students) {
    //   if (students) {
    //     this.tselectedstudents = students;
    //   }
    // },
    // handleClassList(classes) {
    //   if (classes) {
    //     this.tselectedclasses = classes
    // this.ddlClassList.forEach(m => {
    //   classes.forEach(d => {
    //     if (d.PostTagClassID && m.Str_ID) {
    //       if (d.PostTagClassID === m.Str_ID) {
    //         if (this.classList && this.classList.length > 0) {
    //           const exist = this.classList.find(x => x.Str_ID === m.Str_ID);
    //           if (!exist) {
    //             this.tselectedclasses.push(m);
    //           }
    //         } else {
    //           this.tselectedclasses.push(m);
    //         }
    //
    //       }
    //     }
    //   });
    // });
    //   }
    // },
    // handleLevelList(level) {
    //   if (level) {
    //     this.ddlLevelList.forEach(m => {
    //       level.forEach(d => {
    //         if (d.PostTagLevelID && m.Str_ID) {
    //           if (d.PostTagLevelID === m.Str_ID) {
    //             const exist = this.tselectedLevels.find(x => x.Str_ID === m.Str_ID);
    //             if (!exist) {
    //               this.tselectedLevels.push(m);
    //             }
    //           }
    //         }
    //       });
    //
    //     });
    //   }
    // },
    async getTemplateFile(POSTID) {
      try {
        this.$vs.loading()

        let response = await DataSource.shared.getPostFileReturnFilePath(POSTID)
        if (response) {
          this.tselectedfiles = response.Table
        }
        this.$vs.loading.close()
      } catch (e) {
        console.log(e)
      }
    },
    async getTemplateKeyTag(POSTID) {
      let response = await DataSource.shared.getPostKeyTag(POSTID)
      if (response) {
        if (response.Table) {
          response.Table.forEach(d => {
            this.tpostkeytag.push(d.PostKeyTagValue)
          })
        }
      }
    },
    async getDevelopmentGoals(POSTID) {
      let response = await DataSource.shared.getPostDevelopmentGoals(POSTID)
      if (response) {
        if (response.Table) {
          let tempGoalsList = []
          response.Table.forEach(d => {
            tempGoalsList.push({
              Domain: d.PostUpLMDomain,
              Goals: d.PostUpLMGoals,
              Indicator: d.PostUpLMIndicator,
              KeyId: d.PostUpLMPlnMasID,
              remarks: d.PostUpLMRemarks,
              termlyReport: d.PostUpLMTermReport,
            })
          })
          this.tselectedGoals = tempGoalsList
          this.state.PostLearningMoments = tempGoalsList
        }
      }
    },
    clearStudents() {
      this.tselectedstudents = []
      this.tselectedclasses = []
      this.tselectedLevels = []
      this.misAllClasses = null
      this.misselectedalllevels = null
      this.mselectedlevels = null
      this.handleResetGoals()
    },
    async getTemplate(type, length) {
      this.showLoading()

      this.templateList = null
      let numberOfPost
      if (length) {
        numberOfPost = length + 8
      } else {
        numberOfPost = 8
      }
      if (!type) {
        type = this.modal
      }
      const response = await DataSource.shared.getLoadTemplate('Self', type, numberOfPost)
      if (response) {
        if (response.code === '88') {
          window.location.replace('/')
        } else if (response.code === '99') {
          console.log('getPlannerAssignedStudentsGroupByClassID Error')
        } else if (response.code === '2') {
          this.templateList = []

          this.$forceUpdate()

          console.log('getPlannerAssignedStudentsGroupByClassID no record')
        } else {
          for (let d of response.Table) {
            const result = await DataSource.shared.getPostFileReturnFilePath(d.POSTID)
            d.postFile = result.Table
          }
          this.templateList = response.Table
          this.$forceUpdate()
        }
      }
      this.hideLoading()
    },
  },
}
</script>
